import React, { Component } from "react";
import "./PricingPage.scss";

interface PricingPageProps {}

interface PricingPageState {}

class PricingPage extends Component<PricingPageProps, PricingPageState> {
  constructor(props: PricingPageProps) {
    super(props);
    this.state = {};
  }

  render(): React.JSX.Element {
    return (
      <div className="pricing-page">
        <header className="pricing-page-header">
          <h1 className="pricing-page-title">Pricing</h1>
          <p className="pricing-page-subtitle">
            Dummy tiers for the marketing site. Replace with real plans before launch.
          </p>
        </header>

        <div className="pricing-page-plans">
          <article className="pricing-page-plan">
            <h2 className="pricing-page-plan-name">Starter</h2>
            <p className="pricing-page-plan-price">
              <span className="pricing-page-plan-amount">$0</span>
              <span className="pricing-page-plan-period">/mo</span>
            </p>
            <ul className="pricing-page-plan-list">
              <li>Up to 500 AI actions / month (sample)</li>
              <li>1 calendar connection</li>
              <li>Community support</li>
            </ul>
          </article>
          <article className="pricing-page-plan pricing-page-plan--featured">
            <h2 className="pricing-page-plan-name">Pro</h2>
            <p className="pricing-page-plan-price">
              <span className="pricing-page-plan-amount">$29</span>
              <span className="pricing-page-plan-period">/mo</span>
            </p>
            <ul className="pricing-page-plan-list">
              <li>5,000 AI actions / month (sample)</li>
              <li>Multiple calendars</li>
              <li>Priority support</li>
            </ul>
          </article>
          <article className="pricing-page-plan">
            <h2 className="pricing-page-plan-name">Team</h2>
            <p className="pricing-page-plan-price">
              <span className="pricing-page-plan-amount">$99</span>
              <span className="pricing-page-plan-period">/mo</span>
            </p>
            <ul className="pricing-page-plan-list">
              <li>Shared usage pools (sample)</li>
              <li>Admin dashboard</li>
              <li>SLA options</li>
            </ul>
          </article>
        </div>
      </div>
    );
  }
}

export default PricingPage;
